import { APP_BASE } from './base';

/**
 * Registers public/sw.js so the app is installable (Android "Install app", desktop Chrome)
 * and its shell opens offline. Production builds only: in dev Vite serves modules straight
 * from src/ and a worker caching them would only get in the way of HMR.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${APP_BASE}sw.js`).catch(() => {
      /* not fatal: the site works the same without it */
    });
  });
}
